/**
 * Server persistence for the theme choice — the source of truth that follows a
 * person across devices. The browser (localStorage) is the fast-path cache the
 * boot script reads before paint; this keeps the server in step.
 *
 * Mirrors the shape of services/communicationPreferences.ts. Saving is
 * best-effort: the UI applies and caches the choice instantly, and a failed
 * save never blocks the user — their local cache still holds it.
 */
import { webApiClient } from './apiClient';
import type { ThemeChoice } from '../theme/themeController';

export const themePreferencesService = {
  /** Persist the theme choice for the current user. Best-effort. */
  async updateTheme(theme: ThemeChoice): Promise<void> {
    try {
      await webApiClient.put('/users/me/preferences', { theme });
    } catch {
      // The local cache is the fast path; a failed save is not fatal. The next
      // successful save (or the server default) reconciles it.
    }
  },
};
